export const GiftCardType = Object.freeze({
  ecomGiftCard: -1
})
export const GiftCardStateTab = Object.freeze({
  All: 0,
  Active: 1,
  Inactive: 2
})

export const GiftCardTypeTab = Object.freeze({
  ecomGiftCard: 0
})

export const GiftCardSortBy = Object.freeze({
  CreatedAt: 'CreatedAt',
  StartDate: 'StartDate'
})

export const GiftCardSearchType = Object.freeze({
  RecipientEmail: 'recipientEmail',
  SenderEmail: 'senderEmail',
  GiftCardNumber: 'giftCardNumber'
})
